import React from 'react'
import pt from 'prop-types'
import isString from 'lodash/isString'
import { Link } from 'react-router-dom'
import memoWithName from '@/hocs/memoWithName'

import {
  ContainerLink,
  Title,
  ListContainer,
  Container,
  MainTitle,
  TitleContainer,
  FieldsContainer,
  StyledTooltip,
  RowWrapper,
  IconWrapper,
  DiscriptionContainer,
  DiscriptionTitle,
  DiscriptionValue,
} from './styles'

const Widget = ({
  type,
  title,
  icon: Icon,
  path,
  valueList,
  descriptionFields,
  name,
  onlineUsers,
}) => {
  const LinkComponent = path ? Link : React.Fragment
  const linkProps = path
    ? { to: path }
    : {}
  const isBig = type === 'big'
  const color = (icon) => {
    switch (name) {
      case 'AlarmsIcon':
        return `rgba(215, 81, 99, ${icon ? 1 : 0.2})`
      case 'ObjectsIcon':
        return `rgba(71, 128, 243, ${icon ? 1 : 0.2})`
      case 'ActivityLogIcon':
        return `rgba(196, 71, 255, ${icon ? 1 : 0.2})`
      case 'PassportizationIcon':
        return `rgba(76, 153, 84, ${icon ? 1 : 0.2})`
      case 'ReportManagerIcon':
        return `rgba(71, 128, 243, ${icon ? 1 : 0.2})`
      case 'LifeIcon':
        return `rgba(196, 71, 255, ${icon ? 1 : 0.2})`
      default:
        return `rgba(236, 143, 76, ${icon ? 1 : 0.2})`
  }}

  return (
    <ContainerLink isBig={isBig} disabled={path} background={color()} >
      <LinkComponent {...linkProps}>
        <Container isBig={isBig}>
        <TitleContainer>
          <IconWrapper background={color()} >
            <Icon color={color(true)}/>
          </IconWrapper>
          {title && <MainTitle invert>{title}</MainTitle>}
        </TitleContainer>
        
          {/* {descriptionFields.length > 0
            && (
              <FieldsContainer>
                {descriptionFields.map((element, index) => (
                  <RowWrapper>
                    {element.value && (
                      <Title highLight={element.highLight} bf={index === 0}>
                        <StyledTooltip title={isString(element.value) ? element.value : ''}>
                          {element.value || ''}
                        </StyledTooltip>
                      </Title>
                    )}
                  </RowWrapper>
                ))}
              </FieldsContainer>
            )} */}
        </Container>
        <DiscriptionContainer>
          {name === 'UsersIcon' && (
            <>
             <DiscriptionValue color={color(true)}>
                {(onlineUsers || []).length}
              </DiscriptionValue>
              <DiscriptionTitle >
                {'Онлайн'}
              </DiscriptionTitle>
            </>
          )}
        </DiscriptionContainer>
      </LinkComponent>
    </ContainerLink>
  )
}

Widget.defaultProps = {
  type: 'small',
  path: null,
  count: null,
  notification: null,
  iconTitle: null,
  valueList: [],
  descriptionFields: [],
  onlineUsers: [],
}

Widget.propTypes = {
  type: pt.string,
  iconTitle: pt.string,
  path: pt.string,
  count: pt.number,
  notification: pt.string,
  icon: pt.string.isRequired,
  valueList: pt.arrayOf(pt.object),
  title: pt.oneOfType([pt.string, pt.element, pt.node]).isRequired,
  descriptionFields: pt.arrayOf(pt.string),
}

export default memoWithName(Widget)
